import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import CompareSlider from "./CompareSlider";
import "./HomeHero.css";

const HomeHero = () => (
  <section className="hero" id="top" aria-labelledby="hero-title" data-testid="hero-section">
    <div className="tech-grid" aria-hidden="true" />
    <div className="s-container hero-inner">
      <div className="hero-copy">
        <p className="s-label reveal" data-testid="hero-label">Bureau d’études externalisé</p>
        <h1 id="hero-title" className="hero-title reveal" data-delay="1" data-testid="hero-title">
          Donnons forme
          <br />
          <span>à vos idées industrielles.</span>
        </h1>
        <p className="hero-text reveal" data-delay="2" data-testid="hero-text">
          SI2T accompagne les TPE et PME industrielles en conception mécanique, modélisation 3D et plans de fabrication.
          Du besoin initial au dossier technique, ou en renfort ponctuel de votre bureau d'études.
        </p>
        <div className="hero-actions reveal" data-delay="3">
          <Link to="/#contact" className="btn btn-primary" data-testid="hero-cta-primary">
            Présenter mon besoin
            <ArrowRight size={16} strokeWidth={2.2} />
          </Link>
          <Link to="/#etudes" className="btn btn-ghost" data-testid="hero-cta-secondary">
            Voir les études types
          </Link>
        </div>
        <p className="hero-note reveal" data-delay="4">Un interlocuteur direct. Des livrables orientés fabrication.</p>
      </div>

      <div className="hero-visual reveal" data-delay="2">
        <svg className="tech-cross hero-cross-tl" viewBox="0 0 28 28" aria-hidden="true">
          <path d="M14 0v28M0 14h28" stroke="currentColor" strokeWidth="1" />
        </svg>
        <CompareSlider
          before={{
            src: "/img/hero-plateforme-si2t.png",
            imageWidth: 1774,
            imageHeight: 887,
            viewport: [0, 0, 887, 887],
            alt: "",
            label: "01 · Rendu métal",
          }}
          after={{
            src: "/img/hero-plateforme-si2t.png",
            imageWidth: 1774,
            imageHeight: 887,
            viewport: [887, 0, 887, 887],
            alt: "Plateforme d’accès métallique avec plancher en caillebotis et garde-corps : interprétation illustrative en rendu métal et en vue CAO.",
            label: "02 · Vue CAO",
          }}
        />
        <p className="hero-compare-hint">Faites glisser le curseur pour comparer les deux représentations.</p>
        <div className="hero-visual-foot">
          <p className="hero-visual-flow" data-testid="hero-visual-flow">
            <span>Structure métallique</span>
            <ArrowRight size={14} strokeWidth={2} aria-hidden="true" />
            <span>Modélisation 3D</span>
          </p>
          <span className="demo-tag">Visuels générés · illustratifs</span>
        </div>
        <ul className="hero-visual-list" aria-label="Livrables types">
          <li>Modélisation 3D</li>
          <li>Plans de fabrication</li>
          <li>Nomenclatures</li>
          <li>Reprise d'existant</li>
        </ul>
      </div>
    </div>
  </section>
);

export default HomeHero;
